import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { IntegradorApontamento } from '../models/integrador-apontamento';

@Injectable({
  providedIn: 'root'
})
export class IntegradorApontamentoService {

  constructor(private http: HttpClient) {

  }

  consultar(idIntegrador) {
    return this.http.get<IntegradorApontamento[]>(globals.apiUrl + '/api/IntegradorApontamento/Lista',
      { params: new HttpParams().set('idIntegrador', idIntegrador) });
  }

  consultarComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, idIntegrador) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('idIntegrador', idIntegrador);
    return this.http.get<any>(globals.apiUrl + '/api/IntegradorApontamento/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/IntegradorApontamento/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(apontamento: IntegradorApontamento) {
    return this.http.post(globals.apiUrl + '/api/IntegradorApontamento/Salvar', apontamento,
      { responseType: 'text' });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/IntegradorApontamento/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
